import { ReactElement } from 'react';
import { Wrapper } from '@components/common/Wrapper/wrapper';
import { useInfiniteScroll } from '@components/common';
import { MdpMeetings } from '../mdp-meetings/mdp-meetings';
import { NoDataFound } from '@components/common/no-data-found/noDataFound';
import { useMeetingFilterStore } from '@store/meetingFilterStore';
import { useUserRoleType } from '@hooks/useUserRoleType';
import { useSetMainHeader } from '@hooks/useSetMainHeader';
import { useMdpMeetingListQuery } from '@services/hooks/meetings/useMdpMeetingListQuery';
import { MdpMeetingCard } from '../mdp-meeting-card/mdp-meeting-card';

export const MdpMeetingList = (): ReactElement => {
	const { isFetching: queryFetch, error } = useMdpMeetingListQuery();
	const { mdpMeetingFilter } = useMeetingFilterStore();
	const { fetchMore, isFetching, result, plannedMeeting, actualMeeting } = MdpMeetings({
		...mdpMeetingFilter,
	});
	const isRBDM = useUserRoleType();
	const isRBDMMeetCompare = isRBDM === 'RBDM';
	useSetMainHeader(isRBDMMeetCompare ? 'MDP Planning' : 'Assigned Meets');

	useInfiniteScroll(fetchMore);

	return (
		<Wrapper isLoaderVisible={queryFetch || (isFetching && result.length === 0)} isError={error}>
			<>
				<div>
					{isRBDMMeetCompare && (
						<div className="rbdm-meet-compare-wrapper">
							<p>
								MDP Meets Assigned: <b>{plannedMeeting}</b>{' '}
							</p>
							<p>
								MDP Meets Planned: <b>{actualMeeting} </b>{' '}
							</p>
						</div>
					)}
				</div>
				<ul className="meeting-card-wrapper row">
					{result.length > 0 ? (
						result.map((meeting) => {
							const meetingData = meeting._data;

							return <MdpMeetingCard key={meetingData.id} data={meetingData} />;
						})
					) : (
						<NoDataFound />
					)}
				</ul>
			</>
		</Wrapper>
	);
};
